























import { Component, Vue } from 'vue-property-decorator';
import SeatChart from '@/components/SeatChart.vue';
import SeatTable from '@/components/SeatTable.vue';
import BrushGraph from '@/components/BrushGraph.vue';
import Coalitions from '@/components/Coalitions.vue';
import MainHeader from '@/components/MainHeader.vue';
import Headlines from '@/components/Headlines.vue';

@Component({
    components: {
        SeatChart,
        SeatTable,
        BrushGraph,
        Coalitions,
        MainHeader,
        Headlines,
    },
})
export default class Home extends Vue {}
